/**
 * Banner copy — single source of truth for site-wide notice text.
 *
 * Planning: C:/Users/User/.claude/plans/load-gag-skills-for-curried-codd.md
 */

// WHY: Wording supplied verbatim by POD. Do not paraphrase or reformat — this
// string is the single source for the royalty notice rendered on every page
// (Dashboard, Orders) via <RoyaltyPaymentNotice />. Edit here to change it everywhere.
const banners = {
  royaltyNotice:
    "Royalty Payment Notice: Royalty payments to international bank accounts (outside of South Africa) will be processed once the royalty balance reaches USD $100.00. Payments made via PayPal are not subject to a minimum payout threshold.",
};

export default banners;
